<template>
  <div>
    <el-dialog title="导出数据" :visible.sync="dlg_payment_model" :close-on-click-modal="false" @close="dialogClose"
               @opened="openDialog" width="500px">
      <div id="alipay_container" style="height:500px;">
        <h1>支付宝支付</h1>
        <div>
          <div class="form-group">
            <label for="alipayTraceNo">支付宝交易号：</label>
            <input type="text" id="alipayTraceNo" v-model="form.alipayTraceNo" required/>
          </div>
          <div class="form-group">
            <label for="subject">支付说明：</label>
            <input type="text" id="subject" v-model="form.subject" required/>
          </div>
          <div class="form-group">
            <label for="totalAmount">支付金额：</label>
            <input type="number" id="totalAmount" v-model="form.totalAmount" step="0.01" required/>
          </div>
          <div class="form-group">
            <label for="traceNo">订单号：</label>
            <input type="text" id="traceNo" v-model="form.traceNo" required/>
          </div>
          <div class="pb-2">
            <button type="submit" class="submit-btn" @click="submitPayment">提交支付</button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import api from "../api/rest";
import Vue from "vue";

export default {
  props: {
    dlg_payment_model: Boolean,
    payForm: {}
  },
  data() {
    return {
      form: {
        alipayTraceNo: 'alipayTraceNo20241215ss1a1',
        subject: '数据分析服务费',
        totalAmount: 0.1,
        traceNo: 'traceNo20241215122100000',
      },
      dlg_payment: false
    }
  },
  methods: {
    submitPayment() {
      let para = this.form
      const api_url = `/payment/alipay/create?alipayTraceNo=${this.form.alipayTraceNo}&subject=${encodeURIComponent(this.form.subject)}&totalAmount=${this.form.totalAmount}&traceNo=${this.form.traceNo}`;
      api.remote.doGet(api_url).then(function (response) {
        console.log(response)
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = response; // 插入返回的 HTML 表单
        document.body.appendChild(tempDiv);
        tempDiv.querySelector('form').submit(); // 自动提交表单
      })
    },
    generateOrderNumber() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
      const randomDigits = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
      return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}${randomDigits}`;
    },
    openDialog() {
      this.form.totalAmount = this.payForm.totalAmount
      const orderNumber = this.generateOrderNumber();
      this.form.traceNo = orderNumber
    },
    dialogClose() {
      this.dlg_payment_model = false;
      this.$emit("paymentClose", this.dlg_payment_model);
    }
  }
}
</script>


<style scoped>
#alipay_container {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.submit-btn {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #0056b3;
}
</style>


// WEBPACK FOOTER //
// Payment.vue?294359e6